import { blake2b } from "@noble/hashes/blake2";
function getHname(input) {
  const hash = blake2b(new TextEncoder().encode(input), { dkLen: 32 });
  const value = hash[0] | hash[1] << 8 | hash[2] << 16 | hash[3] << 24;
  return Number("0x" + (value >>> 0).toString(16).padStart(8, "0"));
}
export {
  getHname
};
//# sourceMappingURL=getHname.js.map
